__turbopack_context__.v({
  "component": "index-module__0bcCqa__component",
  "component__header": "index-module__0bcCqa__component__header",
  "component__header_v_align": "index-module__0bcCqa__component__header_v_align",
  "component__headline": "index-module__0bcCqa__component__headline",
  "component__headline__dark": "index-module__0bcCqa__component__headline__dark",
  "component__headline__red": "index-module__0bcCqa__component__headline__red",
  "component__icon": "index-module__0bcCqa__component__icon",
  "component__iconAlt": "index-module__0bcCqa__component__iconAlt",
  "component__item": "index-module__0bcCqa__component__item",
  "component__itemHeadline": "index-module__0bcCqa__component__itemHeadline",
  "component__itemList": "index-module__0bcCqa__component__itemList",
  "component__itemListNoWrap": "index-module__0bcCqa__component__itemListNoWrap",
  "component__itemListOdd": "index-module__0bcCqa__component__itemListOdd",
  "component__itemTile": "index-module__0bcCqa__component__itemTile",
  "component__navigationContainer": "index-module__0bcCqa__component__navigationContainer",
  "component__slider": "index-module__0bcCqa__component__slider",
  "component__subhead": "index-module__0bcCqa__component__subhead",
  "component__swiperBtnNext": "index-module__0bcCqa__component__swiperBtnNext",
  "component__swiperBtnPrev": "index-module__0bcCqa__component__swiperBtnPrev",
  "component__swiperBtn__dark": "index-module__0bcCqa__component__swiperBtn__dark",
  "component__swiperBtn__red": "index-module__0bcCqa__component__swiperBtn__red",
  "component__tile": "index-module__0bcCqa__component__tile",
  "component__tileLight": "index-module__0bcCqa__component__tileLight",
  "hide-for-large": "index-module__0bcCqa__hide-for-large",
  "hide-for-large-only": "index-module__0bcCqa__hide-for-large-only",
  "hide-for-medium": "index-module__0bcCqa__hide-for-medium",
  "hide-for-medium-only": "index-module__0bcCqa__hide-for-medium-only",
  "hide-for-small-only": "index-module__0bcCqa__hide-for-small-only",
  "show-for-large": "index-module__0bcCqa__show-for-large",
  "show-for-large-only": "index-module__0bcCqa__show-for-large-only",
  "show-for-medium": "index-module__0bcCqa__show-for-medium",
  "show-for-medium-only": "index-module__0bcCqa__show-for-medium-only",
  "show-for-small-only": "index-module__0bcCqa__show-for-small-only",
  "u-color-black": "index-module__0bcCqa__u-color-black",
  "u-color-blue": "index-module__0bcCqa__u-color-blue",
  "u-color-midnight": "index-module__0bcCqa__u-color-midnight",
  "u-color-primary-dark": "index-module__0bcCqa__u-color-primary-dark",
  "u-color-red": "index-module__0bcCqa__u-color-red",
  "u-color-white": "index-module__0bcCqa__u-color-white",
  "u-theme-black": "index-module__0bcCqa__u-theme-black",
  "u-theme-blue": "index-module__0bcCqa__u-theme-blue",
  "u-theme-dark": "index-module__0bcCqa__u-theme-dark",
  "u-theme-light": "index-module__0bcCqa__u-theme-light",
  "u-theme-red": "index-module__0bcCqa__u-theme-red",
  "u-theme-white": "index-module__0bcCqa__u-theme-white",
});
